import "../../style/footer.css";
import { FaEnvelope, FaInstagram, FaLinkedinIn } from "react-icons/fa";

export default function Footer() {
  return (
    <div className="FooterContainer">
      <div className="FooterText"> Karnov Group Norway AS | Pilestredet 27, 0164 OSLO | Tlf: 22 53 60 70</div>
      <div className="FooterIcons">
        <div className="FooterIcon">
          <a
            className="FooterLink"
            href="https://www.linkedin.com/company/karnov-group-norway"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our LinkedIn page"
          >
            <FaLinkedinIn />
          </a>
        </div>
        <div className="FooterIcon">
          <a
            className="FooterLink"
            href="https://www.instagram.com/karnovstudent/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our Instagram page"
          >
            <FaInstagram />
          </a>
        </div>
        <div className="FooterIcon">
          <a
            className="FooterLink"
            href="mailto:post@karnovgroup.no"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Email us"
          >
            <FaEnvelope />
          </a>
        </div>
      </div>{" "}
      <div className="SaleTerms">
        <a
          className="SaleTermsLink"
          href="https://www.karnovgroup.no/bokvilkar"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Salgsvilkår"
        >
          Salgsvilkår
        </a>
      </div>
    </div>
  );
}
